module.exports = __webpack_public_path__ + "img/img-5.42bcd8b1.png";